/**
 * PURPOSE: Cargar una sola vez los deportes autorizados y su identidad pública.
 * RESPONSIBILITIES: Compartir el contrato /menu_get_sports entre listado y selector de navegación.
 * COLLABORATORS: ListCategoriasSection.jsx, SportSwitcher.jsx y Menu_Permisos.js.
 * ROUTE: winscore/src/services/menuSportsService.js
 */
import axios from "axios";
import API_BASE_URL from "../config/config.js";

export const getMenuSportsForEvent = async ({ iduser, idevent }) => {
  const response = await axios.post(`${API_BASE_URL}/menu_get_sports`, {
    iduser: Number(iduser),
    idevent: Number(idevent),
  });
  return Array.isArray(response.data) ? response.data : [];
};

